import { hasMarkdown } from '@utils/hasMarkdown/hasMarkdown';
import type { Options as ReactMarkdownOptions } from 'react-markdown';
import ReactMarkdown from 'react-markdown';
import { components } from './MarkdownOrText.utils';

export interface MarkdownOrTextProps
  extends Omit<ReactMarkdownOptions, 'children'> {
  description: string;
  children: React.ReactNode;
}
/**
 * Render markdown passed as "description" or default children if "description" is not markdown.
 * Includes some default options for generated markdown.
 *
 * Docs: https://github.com/remarkjs/react-markdown#api
 *  */
export function MarkdownOrText(props: MarkdownOrTextProps) {
  const { children, description, ...options } = props;

  if (hasMarkdown(description)) {
    return (
      <ReactMarkdown components={components} {...options}>
        {description}
      </ReactMarkdown>
    );
  }
  return <>{children}</>;
}
